exports.linkResolver = (doc) => {
  // Get current language from URL (if in browser)
  const languages = ['fr', 'de', 'cs', 'pl', 'hu', 'es', 'it']
  let langPrefix = ''

  if (typeof window !== 'undefined') {
    const pathname = window.location.pathname
    const currentLang = languages.find((lang) => pathname.startsWith(`/${lang}/`))
    if (currentLang) {
      langPrefix = `/${currentLang}`
    }
  }

  if (doc.uid !== 'index' && doc.type === 'page') return `${langPrefix}/${doc.uid}/`
  if (doc.uid === 'index' && doc.type === 'page') return langPrefix || `/`
  if (doc.type === 'category') return `${langPrefix}/${doc.uid}/`
  if (doc.type === 'marketing_page') return `${langPrefix}/project/${doc.uid}/`
  if (doc.type === 'blogpost') return `${langPrefix}/news/${doc.uid}/`
  return langPrefix || '/'
}
